var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.hearing
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page hearing-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_hearing" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "18px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.hearing.hospitalName
                      ? _vm.model.hearing.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "22px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.hearing.reportName
                        ? _vm.model.hearing.reportName
                        : "听力筛查"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "text-align": "left",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                  width: "100%",
                  "border-collapse": "collapse",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.schoolName
                                  ? _vm.model.hearing.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.gradeName
                                  ? _vm.model.hearing.gradeName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.className
                                  ? _vm.model.hearing.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("编号："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.barCode
                                  ? _vm.model.hearing.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("筛查时间："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.physicalDate
                                  ? _vm.model.hearing.physicalDate
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.name
                                  ? _vm.model.hearing.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.sex
                                  ? _vm.model.hearing.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.age
                                  ? _vm.model.hearing.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-top": "20px",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "left",
                      "font-size": "25px",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v("筛查结果")]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "table",
                      width: "100%",
                      "line-height": "80px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "table-cell",
                          width: "50%",
                          "text-align": "center",
                          "font-size": "22px",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _c("span", [_vm._v("左耳：")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.hearing.leftEar
                                ? _vm.model.hearing.leftEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "table-cell",
                          width: "50%",
                          "text-align": "center",
                          "font-size": "22px",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _c("span", [_vm._v("右耳：")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.hearing.rightEar
                                ? _vm.model.hearing.rightEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "80%",
                      "margin-left": "10%",
                      "margin-top": "10px",
                      "margin-bottom": "50px",
                      "border-collapse": "collapse",
                      border: "none",
                      "text-align": "center",
                    },
                  },
                  [
                    _c("tbody", [
                      _vm._m(0),
                      _c("tr", { staticStyle: { "line-height": "35px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [_vm._v("刺激强度")]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.model.hearing.stimulsIntensity)
                              ),
                            ]),
                            _vm._v("dB"),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [_vm._v("60dB~80dB")]
                        ),
                      ]),
                      _c("tr", { staticStyle: { "line-height": "35px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [_vm._v("总反应能量")]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.model.hearing.totalReactionEnergy)
                              ),
                            ]),
                            _vm._v("dB"),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [_vm._v("4.5~18.9dB")]
                        ),
                      ]),
                      _c("tr", { staticStyle: { "line-height": "35px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [_vm._v("总相关度")]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.model.hearing.totalCorrelation)
                              ),
                            ]),
                            _vm._v("%"),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [_vm._v("80%")]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "text-align": "center",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "text-align": "left" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      },
                      [
                        _vm._m(1),
                        _c("div", { staticStyle: { "min-height": "20px" } }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.model.hearing.result
                                  ? _vm.model.hearing.result
                                  : ""
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "tr",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { valign: "top" },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(2),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.hearing.pointOut
                                    ? _vm.model.hearing.pointOut
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      { staticStyle: { background: "#f8f9f9", "line-height": "35px" } },
      [
        _c(
          "td",
          { staticStyle: { "border-collapse": "collapse", border: "none" } },
          [_vm._v("项目名称")]
        ),
        _c(
          "td",
          { staticStyle: { "border-collapse": "collapse", border: "none" } },
          [_vm._v("结果")]
        ),
        _c(
          "td",
          { staticStyle: { "border-collapse": "collapse", border: "none" } },
          [_vm._v("参考值")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【筛查小结】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【温馨提示】"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }